import * as React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'

import EventplannerDesktopMenu from './components/eventplanner-desktop-menu'
import EventplannerMobileMenu from './components/eventplanner-mobile-menu'
import { getMyArtistRequests } from '../../stores/GigRequestArtist/GigRequestArtistReducer'

const mapStateToProps = state => ({
  artistGigRequest: getMyArtistRequests(state),
})

const mapDispatchToProps = dispatch => ({})

const HeaderMenuEventplannerContainer = React.memo(({ artistGigRequest }) => {
  return (
    <>
      <EventplannerDesktopMenu />
      <EventplannerMobileMenu
        artistRequestCount={
          artistGigRequest && artistGigRequest.length > 0 ? artistGigRequest.length : 0
        }
      />
    </>
  )
})

HeaderMenuEventplannerContainer.propTypes = {
  artistGigRequest: PropTypes.arrayOf(PropTypes.shape({})),
}
HeaderMenuEventplannerContainer.defaultProps = {}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(HeaderMenuEventplannerContainer)
